<template>
    <form>
        <!-- <v-container> -->
            <h4 class="ml-3 mt-3">Create index</h4>           
            <v-col
                cols="10"
            >
                <!-- sm="6"
                md="3" -->
                <v-text-field
                    label="Index name"
                    outlined
                    v-model="name"
                    class="indexNameVue"
                    hide-details
                ></v-text-field>                
            </v-col>
            <v-col
                cols="12"
                v-for="(fld, index) in columns" v-bind:key="`${fld.name}`"
            >   
                <div class="d-flex flex-column">
                    <p>Columns</p>
                    <div class="d-flex align-center">
                        <v-autocomplete
                            solo
                            hide-details
                            v-model="columns2"
                            label="Columns"
                            multiple
                            :items="items"                            
                        ></v-autocomplete>
                            <!-- :items="GetTblFields(fld.name, columns)" -->
                            
                        <!-- <v-btn 
                            variant="text" 
                            class="ml-3"
                            @click="columns.splice(index,1)"
                        >
                            <v-icon>
                                mdi-close
                            </v-icon>
                        </v-btn> -->
                    </div>
                </div>
            </v-col>
            <v-col
                cols="12"
            >
                <v-btn 
                    v-if="columns.length < maxColumnsLength" 
                    v-on:click="columns.push({})"
                    variant="text"
                >
                    Add column
                </v-btn>
            </v-col>
            <v-col
                cols="12"
            >
                 <v-btn
                    v-on:click="CreateIndex()"
                >
                    Save
                </v-btn>
            </v-col>
        <!-- </v-container> -->
    </form>
</template>

<script>
import { commonMixin } from '../common.js'

export default {
    mixins: [commonMixin],
    props: {
        tab: {
            type: Object,
            required: true
        },
        state: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            name: '',
            columns: [{}],
            columns2: [],
            items: null
        }
    },
    mounted(){
        // console.log('mount', this.columns);
        this.GetTblFields()
    //   setTimeout(function(){
    //     let el = document.querySelector('.indexNameVue').focus();
    //     console.log('el',el);
        
    //     // el.querySelector('input').focus()
    // },50)
    },
    computed: {
      maxColumnsLength() {
          let tbl = this.state.active_db.data.find(el => el.tablename === this.tab.table)
          console.log('comp tbl', tbl);
          let flds = tbl.fields
          let l = 0;
          for (let i = 0; i < flds.length && i <= 10; i++) {
          const e = flds[i];
          if(e.subtype === 0)
              l++;
        }
        return l;
      }
    },
    methods:{
        GetTblFields(){
            var r = [];            
            let tbl = this.state.active_db.data.find(el => el.tablename === this.tab.table)
            tbl.fields.forEach(element => {
                r.push(element.name);
            });
            this.items = r
        },
        CreateIndex(){
          console.log('CreateIndex()');
          if(!this.name){
            this.ShowAlert('Enter index name');
            return;
          }
          var r = [];
          for (let i = 0; i < this.columns2.length; i++) {
            const e = this.columns2[i];
            if(e)
              r.push(e);
          }
          //console.log('r', r);
          if(!r.length){
            this.ShowAlert('Enter at least one column');
            return;
          }
          console.log('creating index...');
          this.state.queryNumber++
          this.ExecScript(this.tab.db, `CREATE INDEX [${this.name}] ON [${this.tab.table}] (${r.join(',')}) `,response=>{
            if (!response.data[0].err){
              this.LoadDbFromServer(this.tab.db)
              this.ShowAlert('Saved');
            } else {
              this.ShowAlert(response.data[0].msg);
            }
          },true,this.tab.idconnect,this.state.guid)
        },
    },
}
</script>
